import { getAssistedAffiliationDraftService } from "./getAssistedAffiliationDraftService";
import { updateAssistedAffiliationDraftService } from "./updateAssistedAffiliationDraftService";
import { AssistedAffiliationDraft, AssistedAffiliationDraftObservation } from "./types";

const REQUEST_CANCELLED_STATUS = "REQUEST_CANCELLED";

/**
 * Rechaza una solicitud: cambia su estado a cancelada y deja el resto de sus datos intactos.
 * @param documentNumber - Identificación con la que el servicio resuelve el registro.
 * @param observation - Nota del historial que explica el rechazo. Solo viaja si la solicitud no estaba
 * ya rechazada: la alerta que lleva al rechazo puede repetirse sobre una solicitud cancelada, y anotar
 * de nuevo registraría un cambio de estado que no ocurrió.
 * @returns Lo que responda el guardado, que hoy viene vacío. Relanza el error para que la pantalla
 * lo traduzca.
 *
 * Consulta la solicitud antes de guardarla porque el guardado manda el registro completo, no solo el
 * estado: el cuerpo se arma sobre lo que la solicitud ya tenía.
 */
export const rejectAssistedAffiliationDraftService = async (
  documentNumber: string,
  observation?: AssistedAffiliationDraftObservation
): Promise<AssistedAffiliationDraft | null> => {
  const draft = await getAssistedAffiliationDraftService(documentNumber);

  // Si la consulta no trae la solicitud no hay registro sobre el cual cambiar el estado: guardar
  // mandaría un cuerpo sin identificación. Falla a la vista en lugar de eso.
  if (!draft) {
    throw new Error(
      `No se encontró la solicitud ${documentNumber} para rechazarla.`
    );
  }

  const isAlreadyCancelled = draft.status === REQUEST_CANCELLED_STATUS;
  const observations = observation && !isAlreadyCancelled ? [observation] : [];

  return updateAssistedAffiliationDraftService(
    {
      ...draft,
      status: REQUEST_CANCELLED_STATUS,
    },
    observations
  );
};
